import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Button from 'components/Button'
import { useDispatch } from 'react-redux'
import { recallEdit } from 'redux/modules/receptions/actions'

const FirstRepeated = ({ classes, onClose, reception }) => {
  const dispatch = useDispatch()

  const setRepeated = () => {
    dispatch(
      recallEdit(
        {
          recallType: reception.firstRecall ? 'second_recall' : 'first_recall',
          receptionId: reception.id
        },
        (data) => {
          onClose(true)
        },
        (error) => {
          console.log('error', error)
        }
      )
    )
  }

  return (
    <div className={classes.root}>
      <Button
        otherStyles={{ margin: '0 1em 1em 0' }}
        fullWidth
        active
        text={
          reception.secondRecall
            ? 'Было совершено два звонка'
            : reception.firstRecall
            ? 'Был вторичный обзвон'
            : 'Был первичный обзвон'
        }
        onClick={setRepeated}
        disabled={reception.secondRecall}
      />
    </div>
  )
}

const styles = () => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '300px'
  }
})

export default withStyles(styles)(FirstRepeated)
